// Global site footer scaffold.
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Footer() {
  const { t: tr } = useLanguage();
  const t = tr.footer;
  const links = tr.footer.links;

  return (
    <footer>
      <div className="footer-pattern">
        <svg
          width="100%"
          viewBox="0 0 680 55"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.55">
            <rect
              x="18"
              y="8"
              width="22"
              height="7"
              rx="2"
              fill="#411428"
              transform="rotate(-55 18 8)"
            />
            <rect
              x="48"
              y="18"
              width="30"
              height="7"
              rx="2"
              fill="#FF4B32"
              transform="rotate(15 48 18)"
            />
            <rect
              x="88"
              y="6"
              width="14"
              height="7"
              rx="2"
              fill="#411428"
              transform="rotate(-80 88 6)"
            />
            <rect
              x="118"
              y="20"
              width="26"
              height="7"
              rx="2"
              fill="#733635"
              transform="rotate(30 118 20)"
            />
            <rect
              x="158"
              y="8"
              width="20"
              height="7"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-40 158 8)"
            />
            <rect
              x="190"
              y="22"
              width="32"
              height="7"
              rx="2"
              fill="#411428"
              transform="rotate(10 190 22)"
            />
            <rect
              x="232"
              y="5"
              width="16"
              height="7"
              rx="2"
              fill="#733635"
              transform="rotate(-70 232 5)"
            />
            <rect
              x="265"
              y="18"
              width="28"
              height="7"
              rx="2"
              fill="#FF4B32"
              transform="rotate(45 265 18)"
            />
            <rect
              x="308"
              y="8"
              width="20"
              height="7"
              rx="2"
              fill="#411428"
              transform="rotate(-20 308 8)"
            />
            <rect
              x="345"
              y="22"
              width="24"
              height="7"
              rx="2"
              fill="#733635"
              transform="rotate(60 345 22)"
            />
            <rect
              x="385"
              y="6"
              width="18"
              height="7"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-50 385 6)"
            />
            <rect
              x="418"
              y="20"
              width="30"
              height="7"
              rx="2"
              fill="#411428"
              transform="rotate(25 418 20)"
            />
            <rect
              x="460"
              y="9"
              width="22"
              height="7"
              rx="2"
              fill="#733635"
              transform="rotate(-65 460 9)"
            />
            <rect
              x="495"
              y="18"
              width="26"
              height="7"
              rx="2"
              fill="#FF4B32"
              transform="rotate(40 495 18)"
            />
            <rect
              x="535"
              y="5"
              width="16"
              height="7"
              rx="2"
              fill="#411428"
              transform="rotate(-30 535 5)"
            />
            <rect
              x="568"
              y="22"
              width="32"
              height="7"
              rx="2"
              fill="#733635"
              transform="rotate(15 568 22)"
            />
            <rect
              x="610"
              y="8"
              width="20"
              height="7"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-55 610 8)"
            />
            <rect
              x="648"
              y="18"
              width="24"
              height="7"
              rx="2"
              fill="#411428"
              transform="rotate(35 648 18)"
            />
          </g>
        </svg>
      </div>

      <div className="footer-container">
        {/* Column 1: Logo + Social */}
        <div className="footer-section footer-brand">
          <Link to="/" className="footer-logo" aria-label="Home">
            <img src="/logo-footer.png" alt="Khubzah Solutions" />
          </Link>

        <div className="footer-section" id="footer-social">
          <div className="social-icons">
            <a
              href="https://www.tiktok.com/@khubzzh?_r=1&_t=ZS-94zPf8ETgqO"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-tiktok"></i>
            </a>

            <a
              href="https://www.instagram.com/khubzzh?igsh=Ymk0aDIxOHQ3eWJw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-instagram"></i>
            </a>
          </div>
        </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-section footer-links-col">
          <h3 id="footer-links-title">{t.linksTitle}</h3>
          <div id="footer-links">
            <ul>
              <li>
                <Link to="/">{links[0]}</Link>
              </li>
              <li>
                <Link to="/services">{links[1]}</Link>
              </li>
              <li>
                <Link to="/packages">{links[2]}</Link>
              </li>
              <li>
                <Link to="/about">{links[3]}</Link>
              </li>
              <li>
                <Link to="/contact">{links[4]}</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Column 3: Contact */}
        <div className="contact-section footer-contact-col">
          <h3 id="footer-contact-title">{t.contactTitle}</h3>
          <p id="footer-address">
            <i className="bi bi-geo-alt"></i> {t.address}
          </p>
          <p id="footer-email">
            <i className="bi bi-envelope"></i> {t.email}
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p dangerouslySetInnerHTML={{ __html: t.copyright }} />
      </div>
    </footer>
  );
}